











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailNotifications_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendSummaryEmail",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node ).hash = "ce0f64bf6f4423388dc1b0b7aed7fefe";

export default node;
